export const DEFAULT_CURRENCY = 'INR';
export const DEFAULT_LOCALE = 'en-IN';
export const DEFAULT_MINOR_UNITS = 2;

